import PropTypes from 'prop-types';
import moment from 'moment';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@mui/material';
import EditIcon from "../../assets/icons/icon_edit.svg";
import DeleteIcon from "../../assets/icons/icon_trash.svg";

export default function UsersTable({ list, openInPopup, deleteUserType, pageNo, itemsPerPage, ...other }) {
    return (
        <TableContainer component={Paper} {...other}>
            <Table aria-label="customized table" className="custom-table datasets-table">
                <TableHead >
                    <TableRow className='cm_table_head'>
                        <TableCell >#</TableCell>
                        <TableCell >Name</TableCell>
                        <TableCell >Employee code</TableCell>
                        <TableCell >Role</TableCell>
                        <TableCell >Email</TableCell>
                        <TableCell >Created At</TableCell>
                        <TableCell >Action</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {list && list.length > 0 && list.map((row, i) => (
                        <TableRow key={i}>
                            <TableCell>{(i + 1) + ((pageNo - 1) * itemsPerPage)}</TableCell>
                            <TableCell className="datasetname-cell">{row.firstName + " " + row.lastName}</TableCell>
                            <TableCell>{row?.s_uuid ?? '-'}</TableCell>
                            <TableCell>{row?.roleDetails?.roleName ?? '-'}</TableCell>
                            <TableCell>{row?.email ?? '-'}</TableCell>
                            <TableCell> {moment(row?.createdAt).format('DD/MMM/YY')} </TableCell>
                            <TableCell className="edit-cell action-cell">
                                <Button className='form_icon' onClick={() => openInPopup(row)}><img src={EditIcon} /></Button>
                                <Button className='form_icon' onClick={() => deleteUserType(row)}><img src={DeleteIcon} /></Button>
                            </TableCell>
                        </TableRow>))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

UsersTable.propTypes = {
    list: PropTypes.array.isRequired
}